/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_ProductInputs */

const en_group_product = /** @type {(inputs: Group_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const de_group_product = /** @type {(inputs: Group_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Group_ProductInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const group_product = /** @type {((inputs?: Group_ProductInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_ProductInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_group_product(inputs)
	return en_group_product(inputs)
});